import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Nav from "@/components/sections/Nav";
import Hero from "@/components/sections/Hero";
import Personas from "@/components/sections/Personas";
import Features from "@/components/sections/Features";
import Workflow from "@/components/sections/Workflow";
import Benefits from "@/components/sections/Benefits";
import Showcase from "@/components/sections/Showcase";
import Testimonials from "@/components/sections/Testimonials";
import Pricing from "@/components/sections/Pricing";
import PricingCheckout from "@/components/sections/PricingCheckout";
import DownloadCTA from "@/components/sections/DownloadCTA";
import FormsSection from "@/components/sections/FormsSection";
import FAQ from "@/components/sections/FAQ";
import Footer from "@/components/sections/Footer";
import CookieBanner from "@/components/CookieBanner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Reviews from "@/pages/Reviews";

const AppToaster = () => (
    <Toaster
        position="bottom-right"
        toastOptions={{
            style: {
                borderRadius: 0,
                border: "1px solid hsl(var(--ink))",
                background: "hsl(var(--bg))",
                color: "hsl(var(--ink))",
                fontFamily: '"IBM Plex Sans", sans-serif',
            },
        }}
    />
);

const Landing = () => {
    return (
        <div data-testid="landing-page" className="bg-bg text-ink">
            <Nav />
            <Hero />
            <Personas />
            <Features />
            <Benefits />
            <Workflow />
            <Showcase />
            <Testimonials />
            <Pricing />
            <div id="download">
                <DownloadCTA />
            </div>
            <FormsSection />
            <FAQ />
            <Footer />
            <CookieBanner />
        </div>
    );
};

const PricingRoute = () => {
    return (
        <div data-testid="pricing-page" className="bg-bg text-ink">
            <Nav />
            <PricingCheckout />
            <DownloadCTA />
            <FAQ />
            <Footer />
            <CookieBanner />
        </div>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/pricing" element={<PricingRoute />} />
                    <Route path="/checkout" element={<PricingRoute />} />
                    <Route path="/reviews" element={<Reviews />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/dashboard/*" element={<Dashboard />} />
                </Routes>
                <AppToaster />
            </BrowserRouter>
        </div>
    );
}

export default App;
